import { List, Create, Edit } from "../Components/index.js";

export default [
    {
        path: "/admin/setting/user-type",
        component: List,
        name: "setting-user-type-list",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/admin/setting/user-type/:id/edit",
        component: Edit,
        name: "setting-user-type-edit",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/admin/setting/user-type/create",
        component: Create,
        name: "setting-user-type-create",
        meta: {
            requiresAuth: true,
        },
    },
];
